export { default } from './equipment-search-no-result';
